import { IConfig } from './IConfig';
import { Enviroment, IConfigService } from './IConfigService';

export const ProdSubDomains = [
    'ADMIN', 'OFFICER', 'LEGAL', 'CARTORIO', 'APP',
    'ADMIN2', 'OFFICER2', 'LEGAL2', 'CARTORIO2', 'APP2', 'DECODE'
]

const miscellaneousConfig = {
    gATracking: "UA-128076428-1",
    hotjarId: "1082572",
    hotjarSV: "6",
    gTag: "GTM-TLT2PTG",
    fbAppId: "551236288706917",
    googleAppId: "1049493526687-41s8e31v8a0v88ev8lp9hl4ug0oeqthi.apps.googleusercontent.com",
};

const defaultConfig = {
    baseUrl: "admin",
    version: "app_version_admin"
}
const ConfigService: IConfigService = {
    enviroments: {
        LocalHost: {
            env: 'LocalHost',
            apiUrl: 'https://localhost:44300/api',
            baseUrl: defaultConfig.baseUrl,
            version: defaultConfig.version,
            gRecaptcha: '6LdStg4cAAAAAJfkKxvrVsJzzF4WVP1R8pn_Q39q',
            miscellaneousConfig,
            awsConfig: {
                cognitoUserPoolId: "sa-east-1_fjLFQz5ko",
                cognitoRegion: "sa-east-1",
                userPoolWebClientId: "1irt0a4g73qpca71rqpn6qfo14",
                userPoolIdentityPoolId: "sa-east-1:5cc73c52-30ec-426a-84a5-f60bd2f2aa83",
                userPoolIdentityId: "sa-east-1:5cc73c52-30ec-426a-84a5-f60bd2f2aa83"
            }
        },
        Development: {
            env: 'Development',
            apiUrl: 'https://api-dev.precatoriosbrasil.com/api',
            baseUrl: defaultConfig.baseUrl,
            version: defaultConfig.version,
            gRecaptcha: '6LdStg4cAAAAAJfkKxvrVsJzzF4WVP1R8pn_Q39q',
            miscellaneousConfig,
            awsConfig: {
                cognitoUserPoolId: "sa-east-1_fjLFQz5ko",
                cognitoRegion: "sa-east-1",
                userPoolWebClientId: "1irt0a4g73qpca71rqpn6qfo14",
                userPoolIdentityPoolId: "sa-east-1:5cc73c52-30ec-426a-84a5-f60bd2f2aa83",
                userPoolIdentityId: "sa-east-1:5cc73c52-30ec-426a-84a5-f60bd2f2aa83"
            }
        },
        Staging: {
            env: 'Staging',
            apiUrl: 'https://api-uat.precatoriosbrasil.com/api',
            baseUrl: defaultConfig.baseUrl,
            version: defaultConfig.version,
            gRecaptcha: '6LdStg4cAAAAAJfkKxvrVsJzzF4WVP1R8pn_Q39q',
            miscellaneousConfig,
            awsConfig: {
                cognitoUserPoolId: "us-east-1_6NGV0dGlb",
                cognitoRegion: "us-east-1",
                userPoolWebClientId: "7sdbld14vpojc6quuq52vgs0j4",
                userPoolIdentityPoolId: "us-east-1:7d17444a-b63a-491b-92c4-26151c8100bf",
                userPoolIdentityId: "us-east-1:7d17444a-b63a-491b-92c4-26151c8100bf"
            }
        },
        Production: {
            env: 'Production',
            apiUrl: 'https://api.precatoriosbrasil.com/api',
            baseUrl: defaultConfig.baseUrl,
            version: defaultConfig.version,
            gRecaptcha: '6LdStg4cAAAAAJfkKxvrVsJzzF4WVP1R8pn_Q39q',
            miscellaneousConfig,
            awsConfig: {
                cognitoUserPoolId: "sa-east-1_xsQBfAnF5",
                cognitoRegion: "sa-east-1",
                userPoolWebClientId: "4hffcagt2imkvr3o2k4hbeo3r1",
                userPoolIdentityPoolId: "sa-east-1:84caa294-fc0c-4c38-964d-bd3a3138eca6",
                userPoolIdentityId: "sa-east-1:84caa294-fc0c-4c38-964d-bd3a3138eca6"
            }
        }
    },

    getEnv(): Enviroment {
        const subDomain = location.hostname.split('.')[0].toUpperCase();

        if (subDomain.includes("-DEV")) {
            return "Development";
        } else if (subDomain.includes("-UAT")) {
            return "Staging";
        } else if (ProdSubDomains.includes(subDomain)) {
            return "Production";
        } else {
            return "LocalHost";
        }
    },

    getConfig(): IConfig {
        const env = this.getEnv();
        const enviroment = this.enviroments[env]!;
        return enviroment;
    }
}

export default ConfigService;

